import CreatorMonetizationPage from "./CreatorMonetizationPage";

export default CreatorMonetizationPage;
